import { render, staticRenderFns } from "./WantSends.vue?vue&type=template&id=390d1e0e&"
import script from "./WantSends.vue?vue&type=script&lang=js&"
export * from "./WantSends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports